module.exports = __webpack_public_path__ + "static/media/user.126892e8.svg";